module.exports = __webpack_public_path__ + "static/media/game-interviewer5.7e3b52ba.png";